import { TextInput } from '@/components/Form/TextInput'
import { Button } from '@/components/ui/button'
import { usePhoneManagement } from '@/hooks/usePhoneManagement'
import { Check, Trash2 } from 'lucide-react'


// Note: MFA phone number deletion is now handled automatically before setting a new one
export function PhoneNumberField() {
	const {
		tempPhoneNumber,
		setTempPhoneNumber,
		phoneSuccess,
		validPhone,
		phoneLoading,
		handlePhoneUpdate,
		handlePhoneDelete,
		hasPhoneNumber,
		memberPhoneVerified,
		isVerificationMode,
		otpCode,
		setOtpCode,
		otpSending,
		otpVerifying,
		canVerify,
		handleSendOtp,
		handleVerifyOtp,
	} = usePhoneManagement()

	const handleOtpBlur = () => {
		if (otpCode.length === 6) {
			handleVerifyOtp(otpCode)
		}
	}

	if (isVerificationMode) {
		return (
			<div className="space-y-2">
				<div className="flex gap-2 items-center">
					<div className="flex-1">
						<TextInput
							id="verification-code"
							label="Verification Code"
							value={otpCode}
							onChange={(e) => setOtpCode(e.target.value)}
							onBlur={handleOtpBlur}
							placeholder="123456"
							type="text"
							helperText="Enter the 6-digit code sent to your phone"
							showLoading={otpVerifying}
						/>
					</div>
					{memberPhoneVerified && (
						<div className="flex items-center gap-1 text-green-600 text-sm font-medium">
							<Check className="h-4 w-4" />
							Verified
						</div>
					)}
					{canVerify && (
						<Button
							variant="default"
							onClick={handleSendOtp}
							disabled={phoneLoading || otpSending}
							className="flex-shrink-0"
							title="Resend verification code"
						>
							Verify
						</Button>
					)}
					{hasPhoneNumber && (
						<Button
							variant="destructiveOutline"
							size="icon"
							onClick={handlePhoneDelete}
							disabled={phoneLoading}
							className="flex-shrink-0"
							title="Delete phone number"
						>
							<Trash2 className="h-4 w-4" />
						</Button>
					)}
				</div>
			</div>
		)
	}

	return (
		<div className="space-y-2">
			<div className="flex gap-2 items-center">
				<div className="flex-1">
					<TextInput
						id="phone-number"
						label="Phone Number"
						value={tempPhoneNumber}
						onChange={(e) => setTempPhoneNumber(e.target.value)}
						onBlur={() => handlePhoneUpdate(tempPhoneNumber)}
						placeholder="(555) 555-1234"
						type="tel"
						helperText="US numbers only"
						error={!validPhone ? 'Invalid phone number' : undefined}
						showLoading={phoneLoading}
						showSuccess={phoneSuccess}
					/>
				</div>
				{memberPhoneVerified && (
					<div className="flex items-center gap-1 text-green-600 text-sm font-medium">
						<Check className="h-4 w-4" />
						Verified
					</div>
				)}
				{canVerify && (
					<Button
						variant="default"
						onClick={handleSendOtp}
						disabled={phoneLoading || otpSending}
						className="flex-shrink-0"
						title={memberPhoneVerified ? 'Phone number verified' : 'Verify phone number'}
					>
						Verify
					</Button>
				)}
				{hasPhoneNumber && (
					<Button
						variant="destructiveOutline"
						size="icon"
						onClick={handlePhoneDelete}
						disabled={phoneLoading}
						className="flex-shrink-0"
						title="Delete phone number"
					>
						<Trash2 className="h-4 w-4" />
					</Button>
				)}
			</div>
		</div>
	)
}
